export interface Message {
  kind: "error" | "success" | "info";
  text: string;
}

/** Inline status line (uses the legacy `.auth-gate-message` styles). */
export function StatusMessage({ message, id }: { message: Message | null; id?: string }) {
  if (!message) return null;
  return (
    <p
      id={id}
      className={`auth-gate-message ${message.kind}`}
      role={message.kind === "error" ? "alert" : "status"}
    >
      {message.text}
    </p>
  );
}
